import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  language: 'de' | 'en';

  constructor(
    public translateService: TranslateService,
    private location: Location,
  ) {}

  initLanguage(): void {
    this.translateService.addLangs(['en', 'de']);
    let language = navigator.language || (navigator as any).userLanguage;
    language = language.split('-').includes('de') ? 'de' : 'en';
    this.translateService.setDefaultLang(language);

    // Change the URL without navigate:
    this.location.go(language);

    this.language = language;
  }

  changeLanguage(language: 'de' | 'en'): void {
    this.translateService.setDefaultLang(language);
    this.location.go(language);
    this.language = language;
  }
}
